import JoinAddressProvider from './JoinAddressProvider'

export default new JoinAddressProvider()
